import script from "./ModalsManager.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalsManager.vue?vue&type=script&setup=true&lang=js"

import "./ModalsManager.vue?vue&type=style&index=0&id=7675cfb6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7675cfb6"]])

export default __exports__